import { sampleTo, sparkline } from '../lib/format';

/**
 * The 62x20 sparkline in the terminal's "24h" column. Nine points is what the
 * mockup draws, so a dense tick series is sampled down to the same shape.
 * Fewer than two stored ticks means there is no line to draw and the cell goes
 * to an em dash rather than inventing one.
 */
export function Sparkline({ values }: { values: number[] }) {
  const s = sparkline(sampleTo(values, 9));
  if (!s) return <span className="dim">—</span>;
  const stroke = s.dir === 'down' ? '#FF6B6B' : s.dir === 'flat' ? '#5C6B66' : '#B6FF3C';
  return (
    <svg width="62" height="20" viewBox="0 0 62 20" fill="none" aria-hidden="true">
      <polyline
        points={s.points}
        stroke={stroke}
        strokeWidth="1.5"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  );
}
